/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskResultsUnmarkFalsePositive } from "../funcs/riskResultsUnmarkFalsePositive.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  UnmarkRiskResultsFalsePositiveRequest,
  UnmarkRiskResultsFalsePositiveSecurity,
} from "../models/operations/unmarkriskresultsfalsepositive.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type RiskUnmarkResultsFalsePositiveMutationVariables = {
  request: UnmarkRiskResultsFalsePositiveRequest;
  security?: UnmarkRiskResultsFalsePositiveSecurity | undefined;
  options?: RequestOptions;
};

export type RiskUnmarkResultsFalsePositiveMutationData = void;

export type RiskUnmarkResultsFalsePositiveMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * unmarkRiskResultsFalsePositive risk
 *
 * @remarks
 * Undo a false-positive dismissal for one or more risk results.
 */
export function useRiskUnmarkResultsFalsePositiveMutation(
  options?: MutationHookOptions<
    RiskUnmarkResultsFalsePositiveMutationData,
    RiskUnmarkResultsFalsePositiveMutationError,
    RiskUnmarkResultsFalsePositiveMutationVariables
  >,
): UseMutationResult<
  RiskUnmarkResultsFalsePositiveMutationData,
  RiskUnmarkResultsFalsePositiveMutationError,
  RiskUnmarkResultsFalsePositiveMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildRiskUnmarkResultsFalsePositiveMutation(client, options),
    ...options,
  });
}

export function mutationKeyRiskUnmarkResultsFalsePositive(): MutationKey {
  return ["@gram/client", "results", "unmarkFalsePositive"];
}

export function buildRiskUnmarkResultsFalsePositiveMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: RiskUnmarkResultsFalsePositiveMutationVariables,
  ) => Promise<RiskUnmarkResultsFalsePositiveMutationData>;
} {
  return {
    mutationKey: mutationKeyRiskUnmarkResultsFalsePositive(),
    mutationFn: function riskUnmarkResultsFalsePositiveMutationFn({
      request,
      security,
      options,
    }): Promise<RiskUnmarkResultsFalsePositiveMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(riskResultsUnmarkFalsePositive(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
